var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-form-select', {
    class: _vm.fieldClass,
    attrs: {
      "id": _vm.fieldId,
      "required": _vm.isRequired,
      "name": _vm.fieldData.field_name,
      "options": _vm.fieldData.settings.allowed_values
    },
    on: {
      "change": function ($event) {
        return _vm.updateSelected(_vm.selectedValue);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": _vm.isRequired
          }
        }, [_vm._v("\n        -- Select --\n      ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedValue,
      callback: function ($$v) {
        _vm.selectedValue = $$v;
      },
      expression: "selectedValue"
    }
  }), _vm._v(" "), _vm.showOther ? _c('short-text-filter', {
    ref: "explain_field_explain_input",
    staticClass: "raft-js-search-add-label",
    attrs: {
      "id": _vm.fieldId + '-explain',
      "label": _vm.getExplainLabel,
      "get-value": _vm.explainValue,
      "update-method": _vm.updateExplain,
      "use-json-api-filter-manager": false
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }